import {CookieService} from 'core/services/CookieService';
import {SIMPLE_DOMAIN_GENERAL_MASK} from 'core/constants';
import {contextDecorator} from 'core/decorators';
import {
    CITY_APPLIED_STORE_FLAG,
    CITY_CODE_KEY,
    CITY_CODE_KEY_CLIENT,
    CITY_CODE_KEY_UPDATE,
    CITY_ID_KEY,
} from 'modules/locations/constants';
import {HttpClient} from 'core/base/HttpClient';
import {IDetectCityResponse} from 'modules/locations/models';
import dayjs from 'dayjs';

export class LocationService extends HttpClient {
    private readonly cookieService: CookieService;

    constructor() {
        super();

        this.cookieService = CookieService.getInstance();
    }

    private getExpiredCookieDate(): Date {
        return dayjs().add(16, 'day').toDate();
    }

    @contextDecorator('client')
    public applyCity(): void {
        this.cookieService.setInsecureCookie(CITY_APPLIED_STORE_FLAG, 'true', this.getExpiredCookieDate());
    }

    public applyCityCode(code: string, id: string): void {
        const date = this.getExpiredCookieDate();

        this.cookieService.deleteSecureCookie(CITY_CODE_KEY);
        this.cookieService.setSecureCookie(CITY_CODE_KEY, code, date, SIMPLE_DOMAIN_GENERAL_MASK);
        this.cookieService.setInsecureCookie(CITY_CODE_KEY_CLIENT, code, date, SIMPLE_DOMAIN_GENERAL_MASK);
        this.cookieService.setInsecureCookie(CITY_ID_KEY, id, date, SIMPLE_DOMAIN_GENERAL_MASK);
    }

    public applyCityCodeUpdate(code: string): void {
        this.cookieService.setInsecureCookie(CITY_CODE_KEY_UPDATE, code, this.getExpiredCookieDate());
    }

    public deleteCityCodeUpdate(): void {
        this.cookieService.deleteInsecureCookie(CITY_CODE_KEY_UPDATE);
    }

    public async detectCity(): Promise<IDetectCityResponse> {
        const {data} = await this.get<{data: IDetectCityResponse}>({
            options: {credentials: 'include'},
            url: '/cities/detect',
        });

        return data?.data || {};
    }
}
